"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { SectionContainer, TwoColumnLayout } from "./layouts";
import { useWebViewAuthModal } from "@/hooks/client/useWebViewAuthModal";

interface PointsValueSectionProps {
  title: string;
  subtitle: string;
  topLabel?: string;
  ctaText?: string;
}

const PointsValueSection: React.FC<PointsValueSectionProps> = ({
  title,
  subtitle,
  topLabel,
  ctaText,
}) => {
  const { handleClick, AuthModals } = useWebViewAuthModal();

  return (
    <>
      <SectionContainer background="transparent">
        <TwoColumnLayout
          className="lg:items-center"
          leftContent={
            <div className="relative flex w-full items-start justify-start">
              <img
                src="/assets/landing-page/points.jpg"
                alt="Points value"
                className="h-auto w-full max-w-full object-contain lg:max-w-[465px]"
                width={1397}
                height={1524}
                loading="lazy"
              />
            </div>
          }
          rightContent={
            <div className="flex w-full max-w-full flex-col items-center justify-center gap-6 lg:max-w-[566px] lg:items-start lg:justify-center">
              {/* Top Label */}
              {topLabel && (
                <div className="w-full text-center font-figtree text-lg font-medium leading-relaxed text-muted-foreground lg:text-left">
                  {topLabel}
                </div>
              )}

              {/* Title */}
              <div className="w-full text-balance text-center font-figtree text-4xl font-semibold leading-9 text-foreground lg:text-left lg:text-6xl lg:leading-none">
                {title}
              </div>

              {/* Subtitle */}
              <div className="w-full max-w-[472px] text-center font-figtree text-base font-normal leading-6 text-muted-foreground lg:text-left lg:text-xl lg:font-medium lg:leading-7">
                {subtitle}
              </div>

              {/* CTA Button */}
              {ctaText && (
                <Button
                  onClick={handleClick}
                  variant="orange-gradient"
                  className="font-figtree leading-6 text-pure-white"
                >
                  {ctaText}
                </Button>
              )}
            </div>
          }
          gap="xl"
        />
      </SectionContainer>
      <AuthModals />
    </>
  );
};

export default PointsValueSection;
